<template>
    <v-container fluid class="pa-0 pb-8">
        <v-container class="container-custom">
            <Breadcrumbs :title="$t('modules.portalalumno.apps.breadcrumbs.title')" :description="$t('modules.portalalumno.apps.breadcrumbs.description')"></Breadcrumbs>
            <v-row justify="center">
                <v-col class="viewSpaces" sm="12">
                    <div class="my-6">
                            <!-- CANVAS_STUDENT_APP -->
                            <div class="d-flex align-left ">
                                <h4 class="detail my-2"></h4>
                                <h4 class="section-title ml-2">{{ $t('modules.portalalumno.apps.label.canvas_studen_app') }}</h4>
                            </div>
                            <div>
                                <h6 class="section-subtitle ml-2 my-5">{{ $t('modules.portalalumno.apps.label.instrucciones_app_mobile') }}</h6>
                                <ul class="section-content ml-1">
                                    <li>{{ $t('modules.portalalumno.apps.label.instrucciones_app_mobile_1') }}</li>
                                    <li>{{ $t('modules.portalalumno.apps.label.instrucciones_app_mobile_2') }}</li>
                                <ul>
                                    <li>{{ $t('modules.portalalumno.apps.label.instrucciones_app_mobile_3') }}</li>
                                </ul>
                                </ul>
                            </div>     
                                <v-row class="d-flex align-left justify-left my-6">
                                    <a @click="clickAction('Google Play')" class="apps-google mx-3" target="_blank" href='https://play.google.com/store/apps/details?id=com.instructure.candroid&hl=es&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                                        <img alt='Disponible en Google Play' :src="require('@/assets/images/portalalumno/google_play.png')" style="width: 198px; height: 55px;" />
                                    </a>
                                    <a @click="clickAction('App Store')" class="apps-apple mx-3" target="_blank" href="https://itunes.apple.com/ar/app/canvas-student/id480883488?mt=8">
                                        <img :src="require('@/assets/images/portalalumno/app_store_ios.svg')" style="width: 189px; height: 55px;" />
                                    </a>
                                </v-row>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
    import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
    export default {
        name: 'AppsView',
        components: {
            Breadcrumbs,
        },
        methods: {
            clickAction(action) {
                this.$trackEvent('Apps', action, 'Descargas')
            },
        },
        computed:{
            appUrl(){
                if(this.$isTeclab){
                    return {
                        klarway :{
                            video_empadronamiento: 'https://informacion.teclab.edu.ar/hubfs/EX%C3%81MENES%20FINALES%20KLARWAY/Ex%C3%A1menes%20finales%20-%20Klarway_Teclab2022.mp4',
                            instructivo: 'https://f.hubspotusercontent40.net/hubfs/5880041/EX%C3%81MENES%20FINALES%20KLARWAY/Instructivo%20Klarway-%20INSTALACI%C3%93N%20-Teclab.pdf',
                            revisar_instructivo: 'https://f.hubspotusercontent40.net/hubfs/5880041/EX%C3%81MENES%20FINALES%20KLARWAY/Instructivo%20Klarway-%20INSTALACI%C3%93N%20-Teclab.pdf',
                            condiciones: 'https://5880041.fs1.hubspotusercontent-na1.net/hubfs/5880041/EX%C3%81MENES%20FINALES%20KLARWAY/2022/Instructivo_%202022.pdf',
                            appWindows:'https://bivproctor.work/downloads/windows/teclab-release',
                            appIOSDesktop:'https://bivproctor.work/downloads/macos/teclab-release',
                        },
                        zoom :{
                            sitioDescarga: 'https://zoom.us/download',
                            sitio: 'https://zoom.us/'
                        },
                    }
                }else{
                    return {
                        sumadi: {
                            instructivo: 'https://drive.google.com/file/d/17pjyLAbgl5QjLeK5Xt0Ff1l88eix22ic/view?usp=sharing',
                        },
                        klarway :{
                            video_empadronamiento: 'https://f.hubspotusercontent10.net/hubfs/6058217/EXAMENES%20FINALES%20KLARWAY/Examenes%20finales%20-%20Klarway_ipp_final.mp4',
                            instructivo: 'https://f.hubspotusercontent10.net/hubfs/6058217/EXAMENES%20FINALES%20KLARWAY/Instructivo%20Klarway-IPP%20-%20FINAL.pdf',
                            revisar_instructivo: 'https://f.hubspotusercontent10.net/hubfs/6058217/EXAMENES%20FINALES%20KLARWAY/Instructivo%20Klarway-IPP%20-%20FINAL.pdf',
                            condiciones: 'https://6058217.fs1.hubspotusercontent-na1.net/hubfs/6058217/EXAMENES%20FINALES%20KLARWAY/PDF_2%20Final.pdf',
                            appWindows:'https://bivproctor.work/downloads/windows/ipp-release',
                            appIOSDesktop:'https://bivproctor.work/downloads/macos/ipp-release'
                        },
                        zoom :{
                            sitio: 'https://zoom.us/download'
                        },
                    } 
                }
                
            }
        }
    }
</script>

<style scoped lang="sass">
    .container-custom
        font-family: "Roboto", sans-serif
        color: #828482

    .detail
        background-color: var(--v-primary-base)
        width: 20px
        height: 20px
        border-radius: 6px
    .section-title
        font-family: "Roboto-Bold", sans-serif
        color: #05080f
        font-weight: 700
        font-size: 24px
    .section-subtitle
        color: #353c49
        font-family: "Roboto-Medium", sans-serif
        font-weight: 400
        font-size: 20px
        padding: 14px 15px 0px 0px
    .section-content
        font-size: 16px
        font-family: "Roboto-Regular", sans-serif
    .section-content-secondary
        font-size: 14px
        font-family: "Poppins-Regular", sans-serif 
    .apps-google img 
        width: 170px
    .apps-apple img 
        width: 170px
    .apps-huawei img
        width: 170px
    .list-klarway
        list-style: none
    .instructivo 
        font-family: "DM Sans"
        font-size: 12px
        font-weight: 700
        text-decoration: none
        padding: 13px 34px 13px 34px
        border-radius: 23px
        color: white
        width: 178px
    .video-container
        position: relative
        overflow: hidden
        width: 90%
        padding-top: 56.25%
    .responsive-iframe
        position: absolute
        top: 0
        left: 0
        bottom: 0
        right: 0
        width: 100%
        height: 100%
</style>
